export default "__VITE_ASSET__xa9rZY1Z__"